module.exports = __webpack_public_path__ + "static/wish-close-d5ff5482387f5b40441d15805bd1cd69.mp3";